import React from 'react';
import { Calculator, ArrowRight, MessageCircle } from 'lucide-react';
import { WHATSAPP_URL } from '../../lib/utils';
import { brl, Tile, Grupo } from './PesquisaUI';

export const PesquisaResultado = ({ resumo, valorNum, horasNum, t, onAbrirCalculadora }) => {
  const minhaHora = horasNum ? valorNum / horasNum : 0;
  const medianaHora = resumo?.geral?.mediana_hora || 0;
  const difPct = medianaHora ? (minhaHora - medianaHora) / medianaHora : 0;

  return (
    <section className="rounded-2xl bg-white p-5 sm:p-7 shadow-sm border border-slate-100" data-testid="pesquisa-resultado">
      <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-secondary">Resposta registrada</p>
      <h2 className="mt-2 font-heading text-2xl sm:text-[26px] font-bold tracking-tight text-slate-900">Como o seu plantão se compara</h2>

      <div className="mt-5 grid grid-cols-1 gap-2.5 sm:grid-cols-3">
        <Tile k="Seu valor por hora" v={brl(minhaHora)} s={`${brl(valorNum)} em ${horasNum}h`} testId="tile-meu-valor" />
        <Tile
          k="Mediana da pesquisa"
          v={medianaHora ? brl(medianaHora) : 'sem dado ainda'}
          s={resumo ? `${resumo.total} ${resumo.total === 1 ? 'resposta' : 'respostas'}` : ''}
          testId="tile-mediana"
        />
        <Tile
          k="Diferença"
          v={medianaHora ? `${difPct >= 0 ? '+' : ''}${(difPct * 100).toFixed(0)}%` : '—'}
          s={medianaHora ? (difPct >= 0 ? 'acima da mediana' : 'abaixo da mediana') : ''}
          destaque={medianaHora ? (difPct >= 0 ? 'text-secondary' : 'text-orange-700') : ''}
          testId="tile-diferenca"
        />
      </div>

      {resumo && (
        <div className="mt-6" data-testid="pesquisa-grupos">
          <p className="text-[11px] font-semibold uppercase tracking-[0.12em] text-slate-400">Mediana do plantão por grupo</p>
          <Grupo nome="Presencial" bloco={resumo.por_regime?.Presencial} />
          <Grupo nome="Sobreaviso" bloco={resumo.por_regime?.Sobreaviso} />
          <Grupo nome="Hospital público" bloco={resumo.por_unidade?.['Hospital público']} />
          <Grupo nome="Hospital privado" bloco={resumo.por_unidade?.['Hospital privado']} />
          <Grupo nome="Recebe como PF" bloco={resumo.por_vinculo?.PF} />
          <Grupo nome="Recebe como PJ" bloco={resumo.por_vinculo?.PJ} />
          {(resumo.procedimentos?.apendicectomia?.n > 0 || resumo.procedimentos?.acesso_venoso_central?.n > 0) && (
            <div className="mt-5" data-testid="pesquisa-procedimentos">
              <p className="text-[11px] font-semibold uppercase tracking-[0.12em] text-slate-400">Produção por procedimento (mediana)</p>
              <Grupo nome="Apendicectomia" bloco={resumo.procedimentos.apendicectomia} />
              <Grupo nome="Acesso venoso central" bloco={resumo.procedimentos.acesso_venoso_central} />
            </div>
          )}
        </div>
      )}

      <div className="mt-7 rounded-xl bg-primary p-5 text-white" data-testid="pesquisa-cta-calculadora">
        <div className="flex items-start gap-3">
          <div className="w-11 h-11 rounded-full bg-white/15 flex items-center justify-center flex-shrink-0">
            <Calculator className="w-5 h-5 text-white" />
          </div>
          <div>
            <p className="font-heading font-bold text-lg leading-snug">{t('pesquisa-cta-title', 'Quer saber quanto desse plantão vira imposto?')}</p>
            <p className="mt-1.5 text-sm text-white/80">
              {t('pesquisa-cta-text', 'Use a Calculadora de Impostos da Apex: informe seu faturamento e compare Pessoa Física, Simples Nacional, Lucro Presumido e Equiparação Hospitalar em 1 minuto.')}
            </p>
          </div>
        </div>
        <button
          type="button" onClick={onAbrirCalculadora}
          data-testid="pesquisa-abrir-calculadora-button"
          className="mt-4 w-full inline-flex items-center justify-center gap-2 rounded-[10px] bg-secondary hover:bg-secondary-600 px-4 py-3.5 font-semibold text-white transition-colors"
        >
          Calcular meus impostos
          <ArrowRight className="w-4 h-4" />
        </button>
        <a
          href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer"
          data-testid="pesquisa-whatsapp-link"
          className="mt-3 inline-flex items-center gap-2 text-sm text-white/80 hover:text-white transition-colors"
        >
          <MessageCircle className="w-4 h-4" />
          Prefiro falar direto com a Apex
        </a>
      </div>
    </section>
  );
};
